module.exports = ".state-white{background-color:#ffffff}.state-rosado{background-color:#fde0ed}\n"